import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { TranslationService } from 'src/app/services/translation.service';
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.css']
})
export class ActivitiesComponent implements OnInit {
  actvities: Array<any> = [];
  user = this.apiService.user;
  selectedTime = 'all';
  activityCard = false;
  activityData = {};
  selectedcategories = [];
  selectedDates = [];
  categories = [];
  searchText = '';
  searchFilter = 'activity';
  loading = true;
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: '_id',
    textField: 'title',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 5,
    allowSearchFilter: false
  };
  constructor(private apiService: ApiService,
    public translations: TranslationService) { }

  ngOnInit() {
    if (this.apiService.user.profiles) {
      this.apiService.getProfileById(this.apiService.user.profiles._id, this.apiService.user._id).subscribe((res: any) => {
        this.categories = res.data.categoryMap.map(cat => {
          return cat['category'];
        });
        this.categories.sort(function(a, b) {
          return a.rank - b.rank;
        });
      })
    } else {
      this.apiService.getCreatedCategories(this.apiService.user._id).subscribe((res: any) => {
        console.log(res.data);
        this.categories = res.data.map(cat => {
          return cat;
        });
      });
    }
    this.getActivities(this.selectedcategories);
  }

  clearAllFilters(){
    this.selectedTime = 'all';
    this.selectedDates = [];
    this.selectedcategories = [];
    this.searchText = '';
    this.searchFilter = 'activity';
    this.getActivities(this.selectedcategories);
  }

  getActivities(category) {
    this.apiService.filterActivityLogs(this.user._id, category, this.selectedDates, this.searchText, this.searchFilter).subscribe((res: any) => {
      if (this.searchFilter == 'outcome' && this.searchText) {
        this.actvities = res.data.filter(el => el.outcome);
      } else if (this.searchFilter == 'goal' && this.searchText) {
        this.actvities = res.data.filter(el => el.goal);
      } else {
        this.actvities = res.data;
      }
      this.loading = false;
    });
  }

  openActivity(activity) {
    this.activityCard = true;
    this.activityData = activity;
  }

  getTime(seconds) {
    let totalSeconds = seconds;
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let s = totalSeconds % 60;
    return hours + 'h ' + minutes + 'm ' + s + 's';
  }

  closeActivityCard() {
    this.activityCard = false;
  }

  dateFilter(event, obj) {
    if (event.target.value == '7') {
      obj = {
        start: moment().subtract(7, 'days').toDate(),
        end: moment().toDate()
      }
    } else if (event.target.value == '30') {
      obj = {
        start: moment().subtract(30, 'days').toDate(),
        end: moment().toDate()
      }
    } else if (event.target.value == '365') {
      obj = {
        start: moment().subtract(365, 'days').toDate(),
        end: moment().toDate()
      }
    } else if (event.target.value == 'month') {
      obj = {
        start: moment().subtract(1, 'months').startOf('month').toDate(),
        end: moment().subtract(1, 'months').endOf('month').toDate()
      }
    } else if (event.target.value == 'week') {
      obj = {
        start: moment().subtract(1, 'weeks').startOf('week').toDate(),
        end: moment().subtract(1, 'weeks').endOf('week').toDate()
      }
    } else if (event.target.value == 'year') {
      obj = {
        start: moment().subtract(1, 'years').startOf('year').toDate(),
        end: moment().subtract(1, 'years').endOf('year').toDate()
      }
    }
    return obj;
  }

  indexDateChange(event) {
    this.selectedDates = [];
    let obj = this.dateFilter(event, {});
    if (obj.start) {
      this.selectedDates = [obj.start, obj.end];
    }
  }

  applyFilters() {
    let category = this.selectedcategories.map(ele => ele._id);
    this.getActivities(category);
  }

}
